export default __webpack_public_path__ + "static/media/angbao-bonus.5a17c3ff.webp";